import { appDomainProvider } from './helpers/helpers';
import {
  DATA,
  SELECTEDSKUATTRIBUTE
} from '../../../../home24-shared/components/quickview/constants/selectors';

export function getArticleData() {
  const { lngcode } = appDomainProvider();
  const dataElement = document.getElementById(DATA);
  if (!dataElement) {
    return {};
  }
  const object = Object.assign({ lngcode }, JSON.parse(dataElement.innerHTML));
  const selectedChildSku = dataElement.getAttribute(SELECTEDSKUATTRIBUTE);
  const childrenAsArray = Object.keys(object.children).map(
    child => object.children[child]
  );
  const selectedChild = childrenAsArray.find(
    child => child.sku === selectedChildSku
  );

  const arr = Object.keys(object.children);
  let otherSkus = {};
  arr.forEach(name => {
    otherSkus[name] = {
      sku: object.children[name].sku,
      isSellable: object.children[name].isSellable,
      selectedMvcAttributes: object.children[name].selectedMvcAttributes
    };
  });
  const preferedSimple = arr.find(
    key => object.children[key].sku === selectedChild.sku
  );
  return {
    lngcode: lngcode,
    defaultSimple: preferedSimple,
    cfg: object.parent.sku,
    isSellable: selectedChild.isSellable,
    smp: selectedChild.sku,
    stars: {
      isVisible: object.parent.rating.isVisible,
      amount: object.parent.rating.amountOfReviews,
      valueInPercentage: object.parent.rating.valueInPercentage
    },
    name: selectedChild.name,
    variantName: selectedChild.variantName,
    url: selectedChild.url,
    price: {
      sellPrice: selectedChild.price.sellPrice.single,
      isReduced: selectedChild.price.isReduced,
      originalPrice:
        selectedChild.price.originalPrice === null
          ? null
          : selectedChild.price.originalPrice.single,
      priceDifference: selectedChild.price.priceDifference,
      isRecommended: selectedChild.price.isRecommended,
      currency: selectedChild.price.currency
    },
    isValuePack:
      selectedChild.labels &&
      selectedChild.labels.some(label => label === 'valuePack'),
    delivery: {
      isFastDelivery: selectedChild.delivery.isFastDelivery,
      translated: selectedChild.delivery.translated
    },
    images: selectedChild.images,
    mvcAttributes: object.mvcAttributes,
    selectedMvcAttributes: selectedChild.selectedMvcAttributes,
    campaigns:
      selectedChild.campaigns && selectedChild.campaigns.length > 0
        ? selectedChild.campaigns
        : [],
    otherSkus: otherSkus
  };
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/components/quickview/functions/getArticleData.js
 **/